/**
 * Responsavel
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseExclude, ResponseSerialize} from 'simpli-web-sdk'
import {Endereco} from '@/model/resource/Endereco'
import {ResponsavelFilial} from '@/model/resource/ResponsavelFilial'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {TipoCliente} from '@/model/resource/TipoCliente'
import {TipoCriador} from '@/enums/TipoCriador'
import {ApiPermission} from '@/model/resource/ApiPermission'
const sha1 = require('sha1')

/* TODO: review generated class */
export class Responsavel extends Resource {
  idResponsavelPk: number = 0

  @ResponseSerialize(Endereco)
  endereco: Endereco | null = null

  @ResponseSerialize(ResponsavelFilial)
  responsavelFilial: ResponsavelFilial | null = null

  @ResponseSerialize(Responsavel)
  responsavelResponsavel: Responsavel[] | null = null

  /**
   * Valido somente se for servo
   */
  servoIndependente: boolean | null = null

  cnpj: string | null = null
  maxResponsaveis: number | null = null
  jaRedefiniuSenha: boolean | null = null
  dataCriacao: string | null = null
  criadoPeloAdmin: boolean | null = null
  ativo: boolean | null = null
  permitirAssociado: boolean = false
  permitirSerialNumber: boolean = false
  receberNotificacoesCarga: boolean | null = null
  receberNotificacoesTrajeto: boolean | null = null
  auditoriaCepCheckInEmMetros: number | null = null
  auditoriaCepEntregaEmMetros: number | null = null
  limitarConsulta16Dias: boolean = false
  limitarConsulta: boolean = false
  versaoLight: boolean = false
  permitirUsarCombo: boolean = false
  permitirUsarPesquisa: boolean = false
  permitirFotoSilenciosa: boolean = false
  permitirTransbordo: boolean = false
  exibirConsultaPublica: boolean = false
  liberarApi: boolean = false
  permitirSacPublico: boolean = false
  permitirCentroCusto: boolean = false
  permitirDtEmissaoCalcSla: boolean = false
  bloquearCriacaoNotaViaApp: boolean = false
  bloquearCadastrarMesmaDanfe: boolean = false
  permitirIniciarEntregaDepoisFinalizarAnterior: boolean = false

  urlLogoEmpresa: string | null = null
  razaoSocial: string | null = null
  nomeFantasia: string | null = null
  nomeContato: string | null = null
  telefone: string | null = null
  email: string | null = null
  senhaVisualizador: string | null = null
  senhaAdmin: string | null = null
  senhaSac: string | null = null
  idResponsavelFiltroFilialFk: number | null = null
  urlImgCabecalho: string | null = null
  urlImgRodape: string | null = null
  nomeSaraivaFtp: string | null = null
  ip: string | null = null
  perguntaPesquisaSatisfacao: string | null = null
  perguntaPesquisaSatisfacao2: string | null = null
  senhaGrupoEconomico: string | null = null
  senhaIntegracao: string | null = null
  dataVencimento: string | null = null
  permitirRastreamentoDistancia: boolean | null = null
  idFilialFk: number | null = null

  @ResponseExclude()
  senha: string | null = null

  tipoCriador: number | null = null

  idQuemCadastrou: number | null = null
  quemCadastrou: string | null = null

  clienteBloqueado: boolean | null = null
  tipoCliente: TipoCliente | null = null
  usaGrupoEconomico: boolean | null = null
  usaIntegracao: boolean = false
  integracaoTMS: string | null = null

  acessoIlimitadoTransportadores: boolean = false
  clientePossuiTorreDeControle: boolean = false
  nomeResponsavelTorreDeControle: string | null = null

  nomeResponsavelCadastroUltimaModificacao: string | null = null

  dataUltimaModificacao: string | null = null

  temGrupoParceiro: boolean | null = null

  parceiroNome: string | null = null

  habilitarBI: boolean = false
  linkBI: string | null = null
  permitirOutroDocumento: boolean = false
  permitirSms: boolean = false
  apiSomenteGoogle: boolean = false
  linkSacPublico: boolean = false
  exibirPrevisaoEntregaSacPublico: boolean = false
  permitirLigacaoVoip: boolean = false
  permitirLigacaoVoipTorreControle: boolean = false
  permitirWhatsapp: boolean = false
  obrigarAssinatura: boolean = false
  permitirChecklist: boolean = false
  permitirChecklistComponente: boolean = false
  permitirChecklistSeguranca: boolean = false
  permitirRoterizacao: boolean = false
  retornarDistanciaTempoIntegracao: boolean = false
  emitenteTransportador: boolean = false
  webhookOcorrenciaM1: boolean = false
  permitirDevolverNota: boolean = false
  clienteConcreto: boolean = false
  permitirFotoInicioCarga: boolean = false
  envioDeContraSenhaCpf: boolean = false
  envioDeContraSenhaCnpj: boolean = false
  exportacao: boolean = false
  exibirConsultaKade: boolean = false
  permitirFinalizarSemFoto: boolean = false
  obrigatoriedadeRecebedor: boolean = false
  tipoFinalizacaoSucesso: boolean = false
  integracaoCorreios: boolean = false
  permitirAlertaNotaAtraso: boolean = false
  exibirMapaTelaSacPrivado: boolean = false
  permitirDataReal: boolean = false
  permitirDataPrevisao: boolean = false
  permitirCadastrarMesmaDanfe: boolean = false
  apiPublica: boolean = false
  slaHoras: boolean = false
  permitirDevolverNotaFinalizadaParaNaoIniciada: boolean = false

  urlWebhookAutenticacaoM1: string | null = null
  urlWebhookIntegracaoM1: string | null = null
  loginWebhookM1: string | null = null
  keyWebhookM1: string | null = null
  senhaWebhookM1: string | null = null

  senhaDevolverNotaFinalizadaParaNaoIniciada: string | null = null
  senhaDevolverNota: string | null = null
  loginPorDocumento: boolean = true
  outroDocumento: string | null = null

  permitirCheckinAutomatico: boolean = false
  raioCheckinAutomatico: number | null = null

  apiPermission: ApiPermission[] = []
  permitirExcluirNotasFinalizadas: boolean = false
  senhaExcluirNotasFinalizadas: string | null = null
  hasSenhaExcluirNotasFinalizadasPersisted: boolean | null = null

  visualizacaoCnpjFilial: boolean = true
  associarEntregaEntregador: boolean = true
  editarEntrega: boolean = true
  finalizarEntrega: boolean = true
  excluirEntrega: boolean = true
  alterarCriarTipoOcorrencia: boolean = true
  alterarConfig: boolean = true
  visualizacaoEmbarcador: boolean = true
  visualizacaoTransportador: boolean = true

  allowedFileTypes = ['jpg', 'png', 'jpeg']

  get $id() {
    return this.idResponsavelPk
  }
  set $id(val) {
    this.idResponsavelPk = val
  }

  get $tag() {
    return this.razaoSocial || ''
  }

  get idEnderecoFk() {
    if (!this.endereco) return 0
    return this.endereco.$id
  }
  set idEnderecoFk(val) {
    if (!this.endereco) this.endereco = new Endereco()
    this.endereco.$id = val
  }

  get nomeTipoCriador() {
    if (this.tipoCriador == TipoCriador.Admin) {
      return $.t('schema.ListResponsavel.admin')
    } else if (this.tipoCriador == TipoCriador.Motorista) {
      return $.t('schema.ListResponsavel.motorista')
    } else if (this.tipoCriador == TipoCriador.Responsavel) {
      return $.t('schema.ListResponsavel.responsavel')
    }

    return ''
  }

  reset() {
    this.idResponsavelPk = 0
    this.dataVencimento = null
  }

  /**
   * Gets a instance of a given ID of Responsavel
   */
  async getResponsavel(id: number) {
    return await Request.get(`/admin/responsavel/${id}`)
      .name('getResponsavel')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of Responsavel
   */
  async removeResponsavel() {
    return await Request.delete(`/admin/responsavel/${this.$id}`)
      .name('removeResponsavel')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Responsavel
   */
  static async listResponsavel(params: any) {
    return await Request.get(`/admin/responsavel`, {params})
      .name('listResponsavel')
      .as(ResponsavelCollection)
      .getData()
  }

  /**
   * Persists a new instance of Responsavel. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistResponsavel() {
    const request = this.$clone()
    request.senha = this.senha ? sha1(this.senha) : null
    request.senhaVisualizador = this.senhaVisualizador
      ? sha1(this.senhaVisualizador)
      : null
    request.senhaIntegracao = this.senhaIntegracao
      ? sha1(this.senhaIntegracao)
      : null
    request.senhaDevolverNota = this.senhaDevolverNota
      ? sha1(this.senhaDevolverNota)
      : null
    request.senhaExcluirNotasFinalizadas = this.senhaExcluirNotasFinalizadas
      ? sha1(this.senhaExcluirNotasFinalizadas)
      : null
    request.senhaDevolverNotaFinalizadaParaNaoIniciada = this
      .senhaDevolverNotaFinalizadaParaNaoIniciada
      ? sha1(this.senhaDevolverNotaFinalizadaParaNaoIniciada)
      : null

    return await Request.post(`/admin/responsavel`, request)
      .name('persistResponsavel')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of Responsavel to use it in a CSV file
   */
  static async listCsvResponsavel(params: any) {
    return await Request.get(`/admin/responsavel/csv`, {params})
      .name('listCsvResponsavel')
      .as(ResponsavelCollection)
      .getData()
  }

  /**
   * Update dataValidade in an instance of Responsavel
   */
  async updateDataVencimento(date: string) {
    return await Request.post(
      `/admin/responsavel/update-expired-date/${this.$id}`,
      {date}
    )
      .name('updateDataVencimento')
      .asNumber()
      .getData()
  }

  /**
   * Update ativo in an instance of Responsavel
   */
  async updateAtivo(ativo: boolean) {
    return await Request.post(`/admin/responsavel/update-ativo/${this.$id}`, {
      ativo,
    })
      .name('updateAtivo')
      .asNumber()
      .getData()
  }

  /**
   * Check If document exits
   */
  static async existDocument(documento: string | null) {
    return await Request.get(`/admin/responsavel/exist-document/${documento}`)
      .name('existDocument')
      .asBoolean()
      .getData()
  }
}
